import { UseMutateAsyncFunction, useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { UpdateCategoryAssigneesParams, queryClient } from 'api';
import { API_HANDLERS } from 'api/apiHandlers';
import { alert } from 'components';
import { ApiErrors } from 'types';

interface UseUpdateCategoryAssigneesMutationReturn {
  updateCategoryAssigneesMutation: UseMutateAsyncFunction<
    AxiosResponse<unknown, unknown>,
    unknown,
    UpdateCategoryAssigneesParams,
    unknown
  >;
  isLoading: boolean;
}

export function useUpdateCategoryAssigneesMutation(): UseUpdateCategoryAssigneesMutationReturn {
  const { mutateAsync: updateCategoryAssigneesMutation, isLoading } = useMutation(
    API_HANDLERS.CATEGORY.UPDATE_ASSIGNEES,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['document_categories']);
      },
      onError: (error: AxiosError<ApiErrors>) => {
        if (error.response?.data.errors[0]?.description) {
          alert.error(error.response.data.errors[0].description);
        }
      },
    },
  );

  return { updateCategoryAssigneesMutation, isLoading };
}
